<template>
  <div>
    <BoxHeader :msg="msg"></BoxHeader>
    <div>
      <el-container>
        <Menum @callFather="changeData"></Menum>
        <BoxIndex v-show="cur == 0"></BoxIndex>
        <HelloWorld v-show="cur == 1"></HelloWorld>
      </el-container>
    </div>
  </div>
</template>
<style>
.el-header {
  background-color: #334157;
  color: #333;
}

.el-aside {
  color: #333;
}
</style>
<script>
import Menum from "../components/Menum";
import BoxIndex from "../components/BoxIndex";
import BoxHeader from "../components/BoxHeader";
import HelloWorld from "../components/HelloWorld";
export default {
  components: {
    Menum,
    BoxIndex,
    BoxHeader,
    HelloWorld
  },
  data() {
    return {
      msg: "https://www.iming.info/",
      cur: 0
    };
  },
  methods: {
    changeData() {
      this.cur = 1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue